const fonts = {
	font_main_bold: 'fonts/Poppins-Bold.ttf',
	font_main_semibold: 'fonts/Poppins-SemiBold.ttf',
	font_main_regular: 'fonts/Japanese.ttf',
	custom_font: 'assets/custom_font/custom_font.fnt'
};

const symbols_bg = {
	major_1_bg: 'assets/desktop/reel/symbols/symbol_bgs/major_1_bg.png',
	major_2_bg: 'assets/desktop/reel/symbols/symbol_bgs/major_2_bg.png',
	major_3_bg: 'assets/desktop/reel/symbols/symbol_bgs/major_3_bg.png',
	major_4_bg: 'assets/desktop/reel/symbols/symbol_bgs/major_4_bg.png',
	major_5_bg: 'assets/desktop/reel/symbols/symbol_bgs/major_5_bg.png',
	wild_bg: 'assets/desktop/reel/symbols/symbol_bgs/wild_bg.png'
};

const symbols_blurred = {
	minor_1_blurred: 'assets/desktop/reel/symbols/isblurred/minor_1_blurred.png',
	minor_2_blurred: 'assets/desktop/reel/symbols/isblurred/minor_2_blurred.png',
	minor_3_blurred: 'assets/desktop/reel/symbols/isblurred/minor_3_blurred.png',
	minor_4_blurred: 'assets/desktop/reel/symbols/isblurred/minor_4_blurred.png',
	minor_5_blurred: 'assets/desktop/reel/symbols/isblurred/minor_5_blurred.png',
	major_1_blurred: 'assets/desktop/reel/symbols/isblurred/major_1_blurred.png',
	major_2_blurred: 'assets/desktop/reel/symbols/isblurred/major_2_blurred.png',
	major_3_blurred: 'assets/desktop/reel/symbols/isblurred/major_3_blurred.png',
	major_4_blurred: 'assets/desktop/reel/symbols/isblurred/major_4_blurred.png',
	major_5_blurred: 'assets/desktop/reel/symbols/isblurred/major_5_blurred.png',
	scatter_blurred: 'assets/desktop/reel/symbols/isblurred/scatter_blurred.png',
	wild_blurred: 'assets/desktop/reel/symbols/isblurred/wild_blurred.png'
};

const spritesheets = {
	minor_1_spritesheet:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/minors/minor_1_spritesheet.json',
	minor_2_spritesheet:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/minors/minor_2_spritesheet.json',
	minor_3_spritesheet:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/minors/minor_3_spritesheet.json',
	minor_4_spritesheet:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/minors/minor_4_spritesheet.json',
	minor_5_spritesheet:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/minors/minor_5_spritesheet.json',
	major_1_spritesheet:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/major/major_1_spritesheet.json',
	major_2_spritesheet:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/major/major_2_spritesheet.json',
	major_3_spritesheet:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/major/major_3_spritesheet.json',
	major_4_spritesheet:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/major/major_4_spritesheet.json',
	major_5_spritesheet:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/major/major_5_spritesheet.json',
	scatter_spritesheet:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/special/scatter_spritesheet.json',
	wild_spritesheet:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/special/wild_spritesheet.json',

	// wild_frame_appear:
	//   "assets/desktop/reel/animations/spritesheets/payline_spritesheets/wild_frame_appear.json",

	wild_frame:
		'assets/desktop/reel/animations/spritesheets/payline_spritesheets/wild_background.json',
	bonus_special_spritesheet_1:
		'assets/desktop/bonus_round_page/bonus_special_1.json',
	bonus_special_spritesheet_2:
		'assets/desktop/bonus_round_page/bonus_special_2.json',
	bonus_special_spritesheet_3:
		'assets/desktop/bonus_round_page/bonus_special_3.json',
	bonus_reel_special_1:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/special/bonus_reel_special_1.json',

	platform_in:
		'assets/desktop/bonus_round_page/transition/platform_animation_0.json',
	platform_out:
		'assets/desktop/bonus_round_page/transition/platform_animation_dissapear_0.json',

	// featured_img_spritesheet_0:
	//   "assets/desktop/splash_screen_page/featured_img_spritesheet/featured_img_spritesheet_0.json",
	// featured_img_spritesheet_1:
	//   "assets/desktop/splash_screen_page/featured_img_spritesheet/featured_img_spritesheet_1.json",

	main_character:
		'assets/desktop/splash_screen_page/featured_img_spritesheet/major_passive_0.json',
	main_character_active:
		'assets/desktop/splash_screen_page/featured_img_spritesheet/major_active_0.json',
	// feature_img_spritesheet_active_0:
	//   "assets/desktop/splash_screen_page/featured_img_spritesheet/feature_img_spritesheet_active_0.json",
	// feature_img_spritesheet_active_1:
	//   "assets/desktop/splash_screen_page/featured_img_spritesheet/feature_img_spritesheet_active_1.json",
	// feature_img_spritesheet_active_2:
	//   "assets/desktop/splash_screen_page/featured_img_spritesheet/feature_img_spritesheet_active_2.json",
	// feature_img_spritesheet_active_3:
	//   "assets/desktop/splash_screen_page/featured_img_spritesheet/feature_img_spritesheet_active_3.json",
	// feature_img_spritesheet_active_4:
	//   "assets/desktop/splash_screen_page/featured_img_spritesheet/feature_img_spritesheet_active_4.json",
	coin_anim:
		'assets/desktop/win_highlight_popup/coin_spritesheets/coin_anim_desktop.json',

	// quest_widget_icon:
	//   "assets/desktop/header_element/quest_widget/quest_book.json",
	// quest_book_light:
	//   "assets/desktop/header_element/quest_widget/quest_book_light.json",

	// reel_border_spritesheet_active_0:
	//   "assets/desktop/reel/animations/spritesheets/reel_border/reel_border_spritesheet_active_0.json",

	reel_additional_symbol_left:
		'assets/desktop/reel/animations/spritesheets/reel_border/eye_fire_left.json',
	reel_additional_symbol_right:
		'assets/desktop/reel/animations/spritesheets/reel_border/eye_fire_right.json',
	sparkles_spritesheet:
		'assets/desktop/general_elements/sparkles_spritesheet.json',

	// character_fogs_spritesheet:
	//   "assets/desktop/reel/animations/spritesheets/symbol_spritesheets/character_fogs_spritesheet.json",

	// bonus_buy_border_active_spritesheet:
	//   "assets/desktop/bonus_buy_widget/spritesheets/bonus_buy_border_active.json",
	// bonus_buy_border_passive_spritesheet:
	//   "assets/desktop/bonus_buy_widget/spritesheets/bonus_buy_border_passive.json",
	bonus_border: 'assets/desktop/bonus_buy_widget/bonus_border.png',
	total_win_spritesheet:
		'assets/desktop/bonus_round_page/total_win_spritesheet.json',

	// major_frame_spritesheet:
	//   "assets/desktop/reel/animations/spritesheets/payline_spritesheets/major_frame.json",
	major_1_frame: 'assets/desktop/reel/symbols/symbol_bgs/N1.png',
	major_2_frame: 'assets/desktop/reel/symbols/symbol_bgs/N2.png',
	major_3_frame: 'assets/desktop/reel/symbols/symbol_bgs/N3.png',
	major_4_frame: 'assets/desktop/reel/symbols/symbol_bgs/N4.png',
	major_5_frame: 'assets/desktop/reel/symbols/symbol_bgs/N5.png',
	bait_0:
		'assets/desktop/reel/animations/spritesheets/bait_spritesheets/bait_0.json',
	// playactive_btn: "assets/desktop/action_buttons_elements/playactive_btn.json",
	playactive_btn: 'assets/desktop/action_buttons_elements/stop_button.json',

	scatter_text_spritesheet:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/special/scatter_text_spritesheet.json',
	wild_text_spritesheet:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/special/wild_text.json',
	wild_text_spritesheet_x2:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/special/wild_text_x2.json',
	wild_text_spritesheet_x3:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/special/wild_text_x3.json',
	wild_text_spritesheet_x4:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/special/wild_text_x4.json',
	wild_text_spritesheet_x5:
		'assets/desktop/reel/animations/spritesheets/symbol_spritesheets/special/wild_text_x5.json',
	screen_transition_0:
		'assets/desktop/bonus_round_page/transition/new_spider_0.json'
};

const bonusGame = {
	bonus_progress_item_2:
		'assets/desktop/bonus_round_page/bonus_progress_item_2.png',
	bonus_progress_item_1:
		'assets/desktop/bonus_round_page/bonus_progress_item_1.png',
	bonus_trigger: 'assets/desktop/bonus_round_page/bonus_trigger.png',
	bonus_total_win_bg: 'assets/desktop/bonus_round_page/bonus_total_win_bg.png',

	bonus_win_border: 'assets/desktop/bonus_round_page/bonus_win_border.png',
	bonus_character: 'assets/desktop/bonus_round_page/bonus_character.png',
	bonus_character_active:
		'assets/desktop/bonus_round_page/bonus_character_active.png'
};

const reel = {
	reel_divider: 'assets/desktop/reel/elements/reel_divider.png',
	reel_bg: 'assets/desktop/reel/elements/reel_bg.png',
	reel_border: 'assets/desktop/reel/elements/reel_border.png',
	coeffs_left_bg: 'assets/desktop/reel/elements/coeffs_left_bg.png',
	coeffs_right_bg: 'assets/desktop/reel/elements/coeffs_right_bg.png',
	coef_line_left: 'assets/desktop/reel/elements/coef_line_left.png',
	coef_line_right: 'assets/desktop/reel/elements/coef_line_right.png'
};

const dialogue = {
	dialog_header: 'assets/desktop/dialog_element/dialog_header.png',
	dialog_main_bg: 'assets/desktop/dialog_element/dialog_main_bg.png',
	dialog_no_btn: 'assets/desktop/dialog_element/dialog_no_btn.png',
	dialog_yes_btn: 'assets/desktop/dialog_element/dialog_yes_btn.png'
};

const btn_elements = {
	//SWITCHERS
	switcher_back_off: 'assets/desktop/general_elements/switcher_back_off.png',
	switcher_btn_off: 'assets/desktop/general_elements/switcher_btn_off.png',
	switcher_back_on: 'assets/desktop/general_elements/switcher_back_on.png',
	switcher_btn_on: 'assets/desktop/general_elements/switcher_btn_on.png',
	//CHECKBOX
	checkbox_active: 'assets/desktop/general_elements/checkbox_active.png',
	checkbox_inactive: 'assets/desktop/general_elements/checkbox_inactive.png',
	//BET
	increase_bet_icon:
		'assets/desktop/action_buttons_elements/increase_bet_icon.png',
	decrease_bet_icon:
		'assets/desktop/action_buttons_elements/decrease_bet_icon.png',
	//SPIN
	spin_btn: 'assets/desktop/action_buttons_elements/spin_btn.png',
	//   spin_btn_lowered:
	//     "assets/desktop/action_buttons_elements/spin_btn_lowered.png",

	//STOP
	stop_btn: 'assets/desktop/action_buttons_elements/stop_btn.png',
	//   stop_btn_lowered:
	//     "assets/desktop/action_buttons_elements/stop_btn_lowered.png",
	//auto/fast

	btn_small: 'assets/desktop/action_buttons_elements/btn_small.png',

	bet_amount_bg: 'assets/desktop/action_buttons_elements/bet_amount_bg.png',
	infinite_icon: 'assets/desktop/action_buttons_elements/infinite.png'
};

const icons = {
	stop_icon: 'assets/desktop/action_buttons_elements/icons/stop_icon.png',
	spin_icon: 'assets/desktop/action_buttons_elements/icons/spin_icon.png',
	auto_icon: 'assets/desktop/action_buttons_elements/icons/auto_icon.png',
	fast_icon: 'assets/desktop/action_buttons_elements/icons/fast_icon.png'
};

const auto_modal = {
	auto_modal_btn: 'assets/desktop/autospin_modal/auto_modal_btn.png',
	autospin_bg: 'assets/desktop/autospin_modal/autospin_bg.png',
	infinity_symbol_activated:
		'assets/desktop/autospin_modal/infinity_symbol_activated.png',
	infinity_symbol: 'assets/desktop/autospin_modal/infinity_symbol.png',
	selected_amount_bg: 'assets/desktop/autospin_modal/selected_amount_bg.png',
	unselected_amount_bg: 'assets/desktop/autospin_modal/unselected_amount_bg.png'
};

const external_bonus = {
	external_bonus_play_later_btn:
		'assets/desktop/external_bonus/external_bonus_play_later_btn.png',
	external_bonus_play_now_btn:
		'assets/desktop/external_bonus/external_bonus_play_now_btn.png',
	time_frame: 'assets/desktop/external_bonus/time_frame.png',
	bonus_reel_indicator:
		'assets/desktop/external_bonus/bonus_reel_indicator.png',
	bonus_reel_border: 'assets/desktop/external_bonus/bonus_reel_border.png'
};

const settings_page = {
	settings_page_item_bg_off:
		'assets/desktop/settings_page/settings_page_item_bg_off.png',
	settings_page_item_bg_on:
		'assets/desktop/settings_page/settings_page_item_bg_on.png',
	settings_page_main_bg:
		'assets/desktop/settings_page/settings_page_main_bg.png'
};

const header_info = {
	header_info_icon: 'assets/desktop/header_element/header_info_icon.png',
	header_sound_on: 'assets/desktop/header_element/header_sound_on.png',
	header_sound_off: 'assets/desktop/header_element/header_sound_off.png',
	header_settings_icon: 'assets/desktop/header_element/header_settings_icon.png'
};

const widgets = {
	bonus_buy_widget_bg:
		'assets/desktop/bonus_buy_widget/bonus_buy_widget_bg.png',
	bonus_buy_widget_bg_hovered:
		'assets/desktop/bonus_buy_widget/bonus_buy_widget_bg_hovered.png',

	bonus_buy_widget_spritesheet:
		'assets/desktop/bonus_buy_widget/spritesheets/scatter_idle.json',
	// quest_widget_bg:
	//   "assets/desktop/header_element/quest_widget/quest_widget_bg.png",
	// quest_widget_bg_hovered:
	//   "assets/desktop/header_element/quest_widget/quest_widget_bg_hovered.png",

	double_chance_widget_bg:
		'assets/desktop/double_bonus_chance_widget/double_chance_widget_bg.png',
	double_chance_border:
		'assets/desktop/double_bonus_chance_widget/double_chance_border.png',

	double_chance_widget_bg_hovered:
		'assets/desktop/double_bonus_chance_widget/double_chance_widget_bg_hovered.png',
	double_chance_widget_bg_mobile:
		'assets/desktop/double_bonus_chance_widget/double_chance_widget_bg_mobile.png',
	double_chance_widget_bg_mobile_hovered:
		'assets/desktop/double_bonus_chance_widget/double_chance_widget_bg_mobile_hovered.png'
};

const general_elements = {
	logo: 'assets/desktop/header_element/logo.png',
	volatility: 'assets/desktop/splash_screen_page/volatility.png',
	// play_now_btn: "assets/desktop/splash_screen_page/play_now_btn.png",
	// play_now_icon: "assets/desktop/splash_screen_page/play_now_icon.png",
	pagination_arrow_left:
		'assets/desktop/general_elements/pagination_arrow_left.png',
	pagination_arrow_right:
		'assets/desktop/general_elements/pagination_arrow_right.png',
	close_icon_hovered: 'assets/desktop/general_elements/close_icon_hovered.png',
	close_icon: 'assets/desktop/general_elements/close_icon.png',
	// comet: 'assets/desktop/general_elements/comet.png',
	// status_bar_bg: "assets/desktop/status_bar_element/status_bar_bg.png",
	status_bar_mobile: 'assets/mobile/status_bar_element/status_bar_bg.png',

	st_major_1: 'assets/desktop/status_bar_element/major_1.png',
	st_major_2: 'assets/desktop/status_bar_element/major_2.png',
	st_major_3: 'assets/desktop/status_bar_element/major_3.png',
	st_major_4: 'assets/desktop/status_bar_element/major_4.png',
	st_major_5: 'assets/desktop/status_bar_element/major_5.png',

	general_modal_frame:
		'assets/desktop/general_elements/general_modal_frame.png',
	sm_modal_frame: 'assets/desktop/general_elements/sm_modal_frame.png',
	mid_modal_frame: 'assets/desktop/general_elements/mid_modal_frame.png'
};

// const quest_items = {
// quest_ten: "assets/desktop/quest_page/Ten.png",
// quest_j: "assets/desktop/quest_page/Jack.png",
// quest_q: "assets/desktop/quest_page/Queen.png",
// quest_k: "assets/desktop/quest_page/King.png",
// quest_ace: "assets/desktop/quest_page/Ace.png",
// quest_major_5: "assets/desktop/quest_page/Major_5.png",
// quest_major_4: "assets/desktop/quest_page/Major_4.png",
// quest_major_3: "assets/desktop/quest_page/Major_3.png",
// quets_major_2: "assets/desktop/quest_page/Major_2.png",
// quest_major_1: "assets/desktop/quest_page/Major_1.png",
// quest_star: "assets/desktop/quest_page/Star.png",
// quest_coin: "assets/desktop/quest_page/Coin.png",
// quest_scatter: "assets/desktop/quest_page/Scatter.png",
// };

// const quest_page = {
// claimed_btn: "assets/desktop/quest_page/quest_claimed.png",
// go_btn: "assets/desktop/quest_page/go_btn.png",

// quest_activate_btn: "assets/desktop/quest_page/quest_activate_btn.png",

// quest_bg_mobile: "assets/desktop/quest_page/quest_bg_mobile.png",

// quest_page_secondary_bg:
//   "assets/desktop/quest_page/quest_page_secondary_bg.png",
// quest_reward_icon_1: "assets/desktop/quest_page/quest_reward_icon_1.png",
// quest_reward_icon_2: "assets/desktop/quest_page/quest_reward_icon_2.png",
// quest_reward_icon_4: "assets/desktop/quest_page/quest_reward_icon_4.png",
// quest_reward_icon_5: "assets/desktop/quest_page/quest_reward_icon_5.png",

// trophy_icon: "assets/desktop/quest_page/trophy_icon.png",
// clock_icon: "assets/desktop/quest_page/clock_icon.png",

// quest_activated_btn: "assets/desktop/quest_page/quest_activated_btn.png",
// quest_continue_btn: "assets/desktop/quest_page/quest_continue_btn.png",
// // quest_page_header: 'assets/desktop/quest_page/quest_page_header.png',

// quest_page_main_bg: "assets/desktop/quest_page/quest_page_main_bg.png",
// quest_reward_item_bg: "assets/desktop/quest_page/quest_reward_item_bg.png",
// claim_btn_lowered: "assets/desktop/quest_page/claim_btn_lowered.png",
// quest_featured_img: "assets/desktop/quest_page/quest_featured_img.png",

// quest_checked_btn: "assets/desktop/quest_page/quest_checked_btn.png",
// quest_item_bg: "assets/desktop/quest_page/quest_item_bg.png",
// //TODO changed to png
// claim_btn: "assets/desktop/quest_page/claim_btn.png",
// };
const notif_component = {
	error_content_bg: 'assets/desktop/notif_element/error_content_bg.png',
	notif_bg: 'assets/desktop/notif_element/notif_bg.png',
	notif_border: 'assets/desktop/notif_element/notif_border.png',
	notif_btn: 'assets/desktop/notif_element/notif_btn.png'
};

const winHighlight = {
	//WIN HIGHLIGHT
	title_bloodywin: 'assets/desktop/win_highlight_popup/title_bloodywin.png',
	title_megawin: 'assets/desktop/win_highlight_popup/title_megawin.png',
	title_nicewin: 'assets/desktop/win_highlight_popup/title_nicewin.png',
	title_superwin: 'assets/desktop/win_highlight_popup/title_superwin.png',

	core: 'assets/desktop/win_highlight_popup/core.png',
	wing_right: 'assets/desktop/win_highlight_popup/wing_right.png',
	wing_left: 'assets/desktop/win_highlight_popup/wing_left.png'
	// cloud: "assets/desktop/win_highlight_popup/cloud.png",
};

const splash = {
	splash_bg: 'assets/desktop/splash_screen_page/splash_bg.png',
	splash_border: 'assets/desktop/splash_screen_page/splash_border.png',
	is_blurred_bg: 'assets/desktop/splash_screen_page/is_blurred_bg.png'
	// splash_quest_bg_blured:
	//   "assets/desktop/splash_screen_page/splash_quest_bg_blured.png",
	// splash_quest_book: "assets/desktop/splash_screen_page/splash_quest_book.png",
};
export const assetList = {
	...fonts,
	...symbols_bg,
	...symbols_blurred,
	...spritesheets,
	...reel,
	...btn_elements,
	...icons,
	...bonusGame,
	...auto_modal,
	...dialogue,
	...external_bonus,
	...settings_page,
	...header_info,
	...widgets,
	// ...quest_items,
	...general_elements,
	...notif_component,
	...winHighlight,
	...splash
	// ...quest_page,
	// info_page_header: "assets/desktop/general_elements/info_page_header.png",
	// info_page_main_bg: "assets/desktop/general_elements/info_page_main_bg.png",
};
